import Vue from "vue";
import Router from "vue-router";
import Tool from "@/utils/Tool";
import { Message } from "element-ui";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/",
    component: () => import("@/views/index.vue"),
  },
  {
    path: "/articlexieyi",
    component: () => import("@/views/articlexieyi.vue"),
  },
  {
    path: "/subject/index",
    component: () => import("@/views/subject/index.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("oldTopic") == 1) {
        if (from.path == "/oldTopic") {
          return next("/");
        }
        return next({
          path: "/oldTopic",
          query: {
            ...to.query,
          },
        });
      }

      return next();
    },
    // component: () => import("@/views/oldTopic/index.vue"),
  },
  {
    path: "/subject/real",
    component: () => import("@/views/subject/real.vue"),
    beforeEnter: (to, from, next) => {
      const is_noNeed_vip = to.query.is_noNeed_vip || false;
      if (is_noNeed_vip) {
        next({
          path: "/oldTopic",
          query: {
            ...to.query,
            real: to.query.real == 2 ? 2 : 1,
          },
        });
        return;
      }
      const bol = Tool.hasPre();
      if (bol) {
        next({
          path: "/oldTopic",
          query: {
            ...to.query,
            real: to.query.real == 2 ? 2 : 1,
          },
        });
        return;
      } else {
        next("/order/goods");
      }
    },
  },
  {
    path: "/subject/middle",
    component: () => import("@/views/subject/middle.vue"),
  },
  {
    path: "/article/detail",
    component: () => import("@/views/article/detail.vue"),
  },
  {
    path: "/article/articledetail",
    component: () => import("@/views/article/articledetail.vue"),
  },
  {
    path: "/icon/index",
    component: () => import("@/views/icon/iconindex.vue"),
  },
  {
    path: "/category/delicate",
    component: () => import("@/views/category/vipdelicate.vue"),
  },
  {
    path: "/category/special",
    component: () => import("@/views/category/vipspecial.vue"),
  },
  {
    path: "/category/chapter",
    component: () => import("@/views/category/chapter.vue"),
  },
  {
    path: "/member/wrong",
    component: () => import("@/views/member/wrong.vue"),
  },
  {
    path: "/member/order",
    component: () => import("@/views/member/order.vue"),
  },
  {
    path: "/member/member",
    component: () => import("@/views/member/member.vue"),
  },
  {
    path: "/sanli/index",
    component: () => import("@/views/sanli/index.vue"),
  },
  {
    path: "/order/goods",
    component: () => import("@/views/order/goodsbox.vue"),
  },
  {
    path: "/order/index",
    component: () => import("@/views/order/index.vue"),
  },
  {
    path: "/user/index",
    component: () => import("@/views/user/user.vue"),
  },
  {
    path: "/paper/detail",
    component: () => import("@/views/subject/paperdetail.vue"),
  },
  {
    path: "/media/live",
    component: () => import("@/views/media/live.vue"),
  },
  {
    path: "/oldTopic",
    component: () => import("@/views/oldTopic/index.vue"),
  },
  {
    path: "/skillCipher",
    component: () => import("@/views/skillCipher/index.vue"),
  },
  {
    path: "/mastLurn",
    component: () => import("@/views/mastLurn/index.vue"),
  },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();
const whiteList = [
  "/",
  "/oldTopic",
  "/order/goods",
  "/article/detail",
  "/sanli/index",
  "/category/special",
  "/order/index",
  "/user/index",
  '/paper/detail"',
  "/mastLurn",
  "/article/articledetail",
];
router.beforeResolve((to, from, next) => {
  const txt = Tool.isNewUser();
  if (to.path != "/" && txt && to.path !== "/user/index") {
    Message({
      message: txt,
      type: "error",
      duration: 5 * 1000,
    });
    return;
  }

  if (whiteList.indexOf(to.path) !== -1) {
    return next();
  }
  const is_noNeed_vip = to.query.is_noNeed_vip || false;
  if (is_noNeed_vip) {
    next();
    return;
  }
  const bol = Tool.hasPre();
  if (bol) {
    next();
    return;
  } else {
    next("/order/goods");
  }
});
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
